import React from 'react'

type Props = {}

const Point = (props: Props) => {
  return (
    <div>Point</div>
  )
}

export default Point